import api from '../api';
import { User } from '../types';
import repository from './user-repository';
import { getType as getAccType } from '../account';

export class UserStatus {
  static INVITED = 1;

  static ACTIVE = 2;

  static isInvited(status: number): boolean {
    return (status === UserStatus.INVITED);
  }

  static isActive(status: number): boolean {
    return (status === UserStatus.ACTIVE);
  }

  static toString(status: number): string {
    if (this.isInvited(status)) return 'Invited';
    if (this.isActive(status)) return 'Active';
    return 'Unknown';
  }
}

export function getAccountType(userId: string): Promise<number> {
  return repository
    .find(userId)
    .then(user => getAccType(user.accountId));
}

export function update(user: User): Promise<void> {
  return api
    .put(`users/${user.id}`, {
      firstName: user.firstName,
      lastName: user.lastName,
    }).then();
}

export function deleteUser(id: string): Promise<void> {
  return api
    .delete(`users/${id}`)
    .then();
}
